import { ApplicationRoleCode } from '@kcftech/prometheus-client';
import { usePermissions } from 'contexts/PermissionsContext';
import { applicationRoleToName } from 'pages/Settings/Users/shared';
import { useMemo } from 'react';
import { excludeNullAndUndefined } from 'utils/array';

export function useValidUserRoleOptions() {
    const { canAddSentry, canAddGlobalAdmins, canAddSales, canAddUsers } =
        usePermissions();
    const userRoleOptions = useMemo(
        () =>
            excludeNullAndUndefined([
                canAddUsers
                    ? {
                          title: applicationRoleToName[ApplicationRoleCode.User],
                          value: ApplicationRoleCode.User,
                      }
                    : undefined,
                canAddSales
                    ? {
                          title: applicationRoleToName[ApplicationRoleCode.Sales],
                          value: ApplicationRoleCode.Sales,
                      }
                    : undefined,
                canAddSentry
                    ? {
                          title: applicationRoleToName[ApplicationRoleCode.Sentry],
                          value: ApplicationRoleCode.Sentry,
                      }
                    : undefined,
                canAddGlobalAdmins
                    ? {
                          title: applicationRoleToName[ApplicationRoleCode.GlobalAdmin],
                          value: ApplicationRoleCode.GlobalAdmin,
                      }
                    : undefined,
            ]),
        [canAddGlobalAdmins, canAddSales, canAddSentry, canAddUsers],
    );

    return userRoleOptions;
}
